import React from "react";
import MultiLevel from "./MultiLevel";
import SingleLevel from "./SingleLevel";

export function hasChildren(item: { items?: any[] }): boolean {
    const { items: children } = item;
  
    if (children === undefined) {
      return false;
    }
  
    if (!Array.isArray(children)) {
      return false;
    }
  
    if (children.length === 0) {
      return false;
    }
  
    return true;
  }
  
const MenuItem = (props:any) => {
    return  hasChildren(props.item) ? <MultiLevel customNavigationLink={props.item.customNavigationLink} item={props.item} navigateToFirstChild={props?.navigateToFirstChild} closeSideBar={props.closeSideBar}/> : <SingleLevel closeSideBar={props.closeSideBar}  item={props.item}  />
  };

  export default MenuItem;
